/* ── Activity reports: tell Chuck what a teammate just did ───────────────── */

export type ActivityEvent =
  | 'scores-posted'
  | 'message-posted'
  | 'complaint-filed'
  | 'text-opt-in'
  | 'registered';

/**
 * Fire-and-forget report of a deliberate act on the team pages. The server
 * forwards it to the activity webhook; rulings report themselves from the
 * server. Never awaited, never surfaced — a failed report changes nothing
 * for the teammate who just posted.
 */
export function reportActivity(
  event: ActivityEvent,
  summary: string,
  data: Record<string, string | number | boolean | string[]> = {},
): void {
  try {
    void fetch('/api/activity', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, summary, data }),
    }).catch(() => {});
  } catch {
    /* reporting must never break the page */
  }
}
